import httpService from "./httpService";

export default {
  findAllActionsByHcFlowInstanceId(hcFlowInstanceId) {
    let params = {hcFlowInstanceId: hcFlowInstanceId};
    return httpService.get(`/hcStateToState/findAllActionsByHcFlowInstanceId`, {
      params: params
    });
  },

  findAllActionsByHcCaseCommands(hcFlowInstanceId) {
    let params = {hcFlowInstanceId: hcFlowInstanceId};
    return httpService.get(`/hcStateToState/findAllActionsByHcCaseCommands`, {
      params: params
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/hcStateToStateService.js